var _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 25,
    rx: 8.5,
    ry: 2,
    fill: "url(#paint0_radial_386_8829)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5397,
    cy: 24.9678,
    rx: 2.485,
    ry: 0.342761,
    fill: "url(#paint1_radial_386_8829)",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6694 0.0917969L14.2036 6.3667L10.6694 12.5918L7.13525 6.3667L10.6694 0.0917969Z",
    fill: "#019DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6694 0.0917969L14.2036 6.3667L10.6694 12.5918L7.13525 6.3667L10.6694 0.0917969Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4934 6.87715L20.4507 6.83484L17.4361 12.0739L11.5144 12.0952L14.4934 6.87715Z",
    fill: "#BEAAF3",
    stroke: "#BEAAF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84545 6.8791L0.888137 6.83679L3.90274 12.0758L9.82443 12.0972L6.84545 6.8791Z",
    fill: "#FF8A4A",
    stroke: "#FF8A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.113 7.55843L4.29949 11.3583L8.59449 11.3738L6.43383 7.58911L2.113 7.55843Z",
    fill: "#FF8A4A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6336 18.8101L10.6738 24.0651L7.7141 18.8101L10.6738 13.5967L13.6336 18.8101Z",
    fill: "#8EEA36",
    stroke: "#8EEA36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85033 18.2986L0.893021 18.3409L3.90763 13.1019L9.82932 13.0805L6.85033 18.2986Z",
    fill: "#06BF97",
    stroke: "#06BF97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11788 17.6193L4.30437 13.8194L8.59937 13.8039L6.43871 17.5886L2.11788 17.6193Z",
    fill: "#06BF97"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4873 18.3115L20.448 18.3312L17.4509 13.0892L11.5257 13.0903L14.4873 18.3115Z",
    fill: "#FCD300",
    stroke: "#FCD300"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2025 17.5975L17.0299 13.7976L12.7349 13.7984L14.8817 17.5832L19.2025 17.5975Z",
    fill: "#FCD300"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_386_8829",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5 25) rotate(90) scale(2 8.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_386_8829",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5397 24.9678) rotate(90) scale(0.342761 2.485)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsActive);
export default __webpack_public_path__ + "static/media/stars-active.79aa54fd6795e56b324f6a7a51798bbc.svg";
export { ForwardRef as ReactComponent };